import React, {useState} from 'react';

import Chip, {ChipSize} from 'ui-library/chips/Chip';
import ChipSelectInput from 'ui-library/inputs/ChipSelectInput';
import {OptionData} from 'ui-library/menus/MenuConstants';
import {getMatchingOptionDatas} from 'ui-library/menus/MenuUtil';

interface FeatureLibrarySelectorProps {
  onRemove: (featureLibraryId: string) => void;
  onSelect: (featureLibraryId: string) => void;
  optionDatas: Array<OptionData>;
  selectedValues: Array<string>;
}

export default function FeatureLibrarySelector(props: FeatureLibrarySelectorProps): JSX.Element {
  const [query, setQuery] = useState('');
  const matchingOptionDatas = getMatchingOptionDatas(query, props.optionDatas);

  return (
    <ChipSelectInput
      autoFocus={false}
      isMulti={true}
      onSelect={(value) => {
        if (props.selectedValues.includes(value)) {
          props.onRemove(value);
        } else {
          props.onSelect(value);
        }
      }}
      onQueryChange={(e) => {
        setQuery(e.target.value);
      }}
      onRemove={props.onRemove}
      optionDatas={matchingOptionDatas}
      placeholder="Choose one or more feature libraries"
      query={query}
      renderChips={(featureLibraryIds: Array<string>) => (
        <>
          {featureLibraryIds.map((featureLibraryId) => {
            const featureLibraryName = props.optionDatas.find(
              (optionData) => optionData.value === featureLibraryId
            )!.name;
            return (
              <Chip
                key={featureLibraryId}
                onRemove={() => {
                  props.onRemove(featureLibraryId);
                }}
                size={ChipSize.MINI}
                text={featureLibraryName}
              />
            );
          })}
        </>
      )}
      value={props.selectedValues}
    />
  );
}
